import { render, staticRenderFns } from "./Game2.vue?vue&type=template&id=738c7551&scoped=true&"
import script from "./Game2.vue?vue&type=script&lang=js&"
export * from "./Game2.vue?vue&type=script&lang=js&"
import style0 from "./Game2.vue?vue&type=style&index=0&id=738c7551&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738c7551",
  null
  
)

export default component.exports